import {
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
  useTheme,
} from "@mui/material";
import React from "react";
import { PropsWithChildren } from "react";

const sizes = {
  xl: 3.5,
  l: 2,
  m: 1.5,
  sm: 1,
};
type TypographyProps = MuiTypographyProps & {
  size?: keyof typeof sizes;
};

const Typography = (props: PropsWithChildren<TypographyProps>) => {
  const { size = "m" } = props;
  const theme = useTheme();
  return (
    <MuiTypography
      fontSize={`${sizes[size]}rem`}
      color={theme.palette.common.white}
      {...props}
    >
      {props.children}
    </MuiTypography>
  );
};

export default Typography;
